import { useEffect } from 'react';
import { ComponentProps, ComponentType } from 'react';

export default function withTitle( pageTitle: string ) {
	return ( Component: ComponentType ) => {
		return function WithTitle( props: ComponentProps<typeof Component> ) {
			useEffect( () => {
				document.title = `${pageTitle} – Automattic Host Partner Portal`;
			} );

			return <Component { ...props } />;
		};
	};
}
